import React, {useMemo, useState} from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux'
import PurchasingGroupSectionService from "services/PurchasingGroupSectionService";
import {useParams, withRouter} from "react-router";
import Loading from "components/Loading";
import {PurchasingGroupStageSections, StageSectionNameToSectionParam} from "../constants/PurchasingGroupStageSections";
import {DemandValidationSectionStatus} from "constants/DemandValidationSectionStatus";
import PurchasingGroupStageSection from "../components/PurchasingGroupStageSection";
import NavigationBar from "components/complex/floatingMenu/NavigationBar";
import createButton from "components/complex/floatingMenu/createButton";
import SaveIcon from "@material-ui/icons/Save";
import ArrowIcon from "@material-ui/icons/KeyboardArrowUp";
import {makeStyles} from "@material-ui/core";
import RouterPath from "libs/RouterPath";
import reduxStore from 'redux/store'
import useSnackbar from "hooks/useSnackbar";
import Tr from "translations/Translations";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";
import RefreshIcon from "@material-ui/icons/Refresh";
import ClearIcon from '@material-ui/icons/Clear';
import MailIcon from "@material-ui/icons/Mail";
import {simpleConfirm} from "libs/ConfirmNotification";
import ListIcon from "@material-ui/icons/List";
import DemandRelatedObjectsPopup from "components/popup/relatedObjects/DemandRelatedObjectsPopup";

const useStyle = makeStyles(theme => ({
    root: {
        height: '100%',
        '&>*:not(:first-child)': {
            marginTop: theme.spacing(2)
        }
    },
    floatingMenu: {
        marginBottom: theme.spacing(2),
        position: 'sticky',
        zIndex: theme.zIndex.appBar - 1,
        top: 108
    }
}));

function PurchasingGroupStage(
    {
        mainSectionName,
        stageSections,
        purchasingGroupHeader,
        stateCloseValidator,
        formValues,
        dealing,
        dealingsList
    }
) {
    const classes = useStyle();
    const params = useParams();
    const groupId = params.id;
    const stage = params.stage;
    const section = params.section;
    const {enqueueErrorSnackbar, enqueueInfoSnackbar} = useSnackbar();
    const [relatedObjectPopup, setRelatedObjectPopup] = useState(false)

    const navigationBarButtons = useMemo(() => {
        const changes = section !== StageSectionNameToSectionParam.TEMPLATE && (stateCloseValidator && stateCloseValidator() === false);
        const buttons = [];
        if (changes) {
            buttons.push(createButton('discard_changes', () => closeSection(false), 'outlined', ClearIcon, "primary", !section));
        }
        buttons.push(createButton(changes ? 'save' : 'close', () => closeSection(changes), undefined, changes ? SaveIcon : ArrowIcon, "primary", !section));

        if (stageSections) {
            const stageSection = stageSections[mainSectionName] || {};

            if (stageSection && stageSection.emailListAvailable)
                buttons.push(createButton('email_list', () => {
                    const href = RouterPath.createPath(RouterPath.purchasingGroup.MP_PURCHASING_GROUP_GROUP_ID_EMAIL_LIST, {id: groupId});
                    RouterPath.redirect(href)
                }, undefined, MailIcon, 'primary', false, true));

            if (stageSection && stageSection.showUpdateNumber)
                if (purchasingGroupHeader.showUpdateNumber) {
                    buttons.push(createButton("update_number", () => enqueueInfoSnackbar("Nie zaimplementowano"), undefined, RefreshIcon, "primary", !!section, true));
                }

            if (purchasingGroupHeader && purchasingGroupHeader.hasDemand)
                buttons.push(createButton('related_objects', () => setRelatedObjectPopup(true),
                    "outlined", ListIcon, 'primary', false, true));

        }
        return buttons;
        // eslint-disable-next-line
    }, [section, stageSections, closeSection, purchasingGroupHeader, enqueueInfoSnackbar, formValues, stateCloseValidator, dealingsList, dealing])


    const closeSection = (save) => {
        if (save) {
            const {form} = reduxStore.getState();
            const func = form[section];
            if (func) {
                func();
            } else {
                enqueueErrorSnackbar(Tr("unknown_error_message"));
            }
        } else {

            if (section === StageSectionNameToSectionParam.TEMPLATE && stateCloseValidator && !stateCloseValidator()) {
                simpleConfirm("modification_cancel_popup_text", () => {
                    RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.purchasingGroup.MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR, {
                        id: groupId,
                        stage: stage
                    }))
                })
            } else {
                RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.purchasingGroup.MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR, {
                    id: groupId,
                    stage: stage
                }))

            }
        }
    };


    if (!stageSections) return <Loading/>
    return (<div className={classes.root}>
            {(!!(navigationBarButtons?.length)) &&
                <div className={classes.floatingMenu}>
                    <NavigationBar buttons={navigationBarButtons}/>
                </div>
            }

            {Object.keys(PurchasingGroupStageSections).filter((sectionId) => {
                const section = stageSections[sectionId];
                return !!section && section.status !== DemandValidationSectionStatus.UNAVAILABLE
            })
                .map((sectionId) => {
                    return (<PurchasingGroupStageSection key={sectionId} validationSection={stageSections[sectionId]}/>)
                })}
            {
                relatedObjectPopup &&
                <DemandRelatedObjectsPopup relatedObjectServiceFunction={PurchasingGroupStage1Service.getRelatedObjects} demandId={groupId} onClose={() => setRelatedObjectPopup(false)}/>
            }
        </div>
    )
}

PurchasingGroupStage.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    stageSections: state.resources[PurchasingGroupSectionService.PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID],
    purchasingGroupHeader: state.resources[PurchasingGroupStage1Service.PURCHASING_GROUP_HEADER_RESOURCE_ID],
    stateCloseValidator: state.stepper.stateCloseValidator,
    formValues: state.formValues,
    dealing: state.resources.dealing,
    dealingsList: state.resources.dealingsList,
}), {})(withRouter(PurchasingGroupStage));
